import { render, staticRenderFns } from "./basicMessage.vue?vue&type=template&id=514fd15e&scoped=true&"
import script from "./basicMessage.vue?vue&type=script&lang=js&"
export * from "./basicMessage.vue?vue&type=script&lang=js&"
import style0 from "./basicMessage.vue?vue&type=style&index=0&id=514fd15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514fd15e",
  null
  
)

export default component.exports